export const ADDCART = "ADDCART";
export const REMOVEITEM = "REMOVEITEM";
export const COUPON = "COUPON";
export const EMPTYCART = "EMPTYCART";
export const ISAUTH = "ISAUTH";
